<div class="header-container bg-primary text-white p-1 pb-0">
  <div class="logo-container">
    <a href="#" class="sidebar-toggle" (click)="toggleSidebar()">
      <img class="sd-icon" alt="Shikshawith" src="./images/logo.png">
    </a>
    @if (user?.isAuthenticated) {
    <span>
      <span class="title">
        <img class="logo px-2" alt="Shikshawith" [src]="logoUrl" />
      </span>
    </span>
    }
  </div>
  @if (!readOnlyMode) {
  <div class="dropdown me-4 d-none d-md-block">
    <button type="button" class="btn btn-outline-info white dropdown-toggle" data-bs-toggle="dropdown"
      aria-haspopup="true" aria-expanded="false">
      <i class="fa fa-globe white mr-1 d-none d-md-inline-block"></i> {{db.lang}}
    </button>
    <div class="dropdown-menu">
      @for (item of languages; track item) {
      <div class="dropdown-item" href="javascript:void();" (click)="onLanguageChanged(item.code);">
        <i class="fa fa-globe blue mr-1"></i> {{item.name}}
      </div>
      }
    </div>
  </div>
  }

  @if (user?.isAuthenticated) {
  <div class="user-section dropdown">
    <span class="row username" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
      aria-expanded="false">
      <div class="col-auto p-1">
        <img class="user-avatar" [src]="user.image || fallbackImage" [alt]="user.displayName" />
      </div>
      <div class="col p-1 d-none d-md-inline-block">
        <div class="dropdown-toggle">{{ user.name | truncate:[15] }}</div>
        <div class="role">{{user.role}} @if (user.role == 'student') {
          <span>({{user.class?.name}})</span>
          }
        </div>
      </div>
    </span>
    @if (!readOnlyMode) {
    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" href="javascript:void();" [routerLink]="['/users/my-profile']">
        <i class="fa fa-user-alt pr-2 fuchsia"></i> {{db.labels.myProfile}}
      </a>
      <a class="dropdown-item" href="javascript:void();" [routerLink]="['/users/change-password']">
        <i class="fa fa-key pr-2 olive"></i> {{db.labels.changePassword}}
      </a>
      <a class="dropdown-item" href="javascript:void();" (click)="expireCache();">
        <i class="fa fa-chalkboard-teacher pr-2 green"></i> {{db.labels.refreshCache}}
      </a>
      <a class="dropdown-item" href="javascript:void();" (click)="onAvatarChange();">
        <i class="fa fa-solid fa-user-astronaut pr-2 violet"></i>
        {{db.labels.setAvatar || 'Change Avatar'}}
      </a>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="javascript:void();" (click)="logoff();">
        <i class="fa fa-sign-out-alt pr-2 red"></i> LogOff
      </a>
    </div>
    }
    @if (readOnlyMode) {
    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" href="javascript:void();" (click)="logoff();">
        <i class="fa fa-sign-out-alt pr-2 red"></i> LogOff
      </a>
    </div>
    }
  </div>
  }
  @if (avatarDialog.visible) {
  <p-dialog header="Choose Your Avatar" [(visible)]="avatarDialog.visible" [modal]="true" styleClass="dialog-avatar">
    <div class="row">
      @for (item of avatars; track item) {
      <div class="col text-center">
        <img class="avatar mb-3" [src]="item.img" [alt]="user.displayName" (click)="setAvatar(item);" />
      </div>
      }
    </div>
    <!-- <div class="text-center">
      <button class="btn btn-primary w-50" gText="ok"></button>
    </div> -->
  </p-dialog>
  }
</div>